module.exports = __webpack_public_path__ + "static/media/ringing.ebf848c0.mp3";